import styled from 'styled-components';
import { Text } from 'components';
import { REFERRAL_COLORS } from './theme';

const Card = styled.div`
  background-color: ${REFERRAL_COLORS.bg};
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 20px;
  padding: 20px;
  margin: 16px;
`;

const InviteBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background-color: ${REFERRAL_COLORS.cta};
  border-radius: 12px;
  padding: 14px 16px;
  margin: 16px;
`;

const ProgressTrack = styled.div`
  height: 12px;
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0.08);
  overflow: hidden;
  margin-top: 16px;
`;

const ProgressFill = styled.div`
  height: 100%;
  border-radius: 6px;
  width: ${(props) => props.$percent}%;
  background-color: ${(props) => (props.$success ? REFERRAL_COLORS.success : REFERRAL_COLORS.cta)};
  transition: width 0.3s ease;
`;

const StatsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
`;

const ReferralBanner = ({ senderName, momentsViewed, threshold, bonusPoints }) => {
  const isComplete = momentsViewed >= threshold;
  const percent = Math.min((momentsViewed / threshold) * 100, 100);
  const remaining = Math.max(threshold - momentsViewed, 0);

  // A single-post referral ("View My FanCam Post") completes on its first view, so it goes
  // straight from this invite to the completed card.
  if (momentsViewed <= 1 && !isComplete) {
    return (
      <InviteBanner>
        <Text style={{ fontSize: 24, lineHeight: 1 }}>🎁</Text>
        <Text b1 bold col={REFERRAL_COLORS.white}>
          {threshold === 1
            ? `Sent by your friend — view their FanCam moment to earn ${bonusPoints} points together.`
            : `Sent by your friend — view ${threshold} moments to earn ${bonusPoints} points together.`}
        </Text>
      </InviteBanner>
    );
  }

  const headline = isComplete
    ? `🎉 You did it! You and ${senderName} earned ${bonusPoints} points together.`
    : `Earn ${bonusPoints} points with ${senderName}`;

  return (
    <Card>
      <Text h3 bold col={REFERRAL_COLORS.white}>
        {headline}
      </Text>
      <ProgressTrack>
        <ProgressFill $percent={percent} $success={isComplete} />
      </ProgressTrack>
      {!isComplete && (
        <>
          <StatsRow>
            <Text b2 bold col={REFERRAL_COLORS.white}>
              {momentsViewed} / {threshold} Viewed
            </Text>
            <Text b2 col={REFERRAL_COLORS.mutedText}>
              {remaining} Left
            </Text>
          </StatsRow>
          <Text b2 col={REFERRAL_COLORS.mutedText} marg="8px 0 0">
            Keep viewing FanCam moments to unlock your reward. Once you hit {threshold}, both you
            and your friend unlock the points!
          </Text>
        </>
      )}
    </Card>
  );
};

export default ReferralBanner;
